import LocaleStrings from '@/PrimeVue/themePreset/types/localeStrings';

function buildAutoCompletePassThrough(localeStrings: LocaleStrings) {
  return {
    inputMultiple: 'pv-autocomplete-multiple',
    root: 'pv-autocomplete-input-container',
    pcChip: { root: 'pv-option-selected' },
    dropdown: { // WCAG add title to dropdown button
      title: localeStrings.autoComplete.dropdown.title
    }
  };
}

export default buildAutoCompletePassThrough;